<template>
  <div class="px-4">
    <dynamic-zone-renderer v-if="content" :components="content.components" :add-paddings="false"></dynamic-zone-renderer>
    <div>
      <div v-for="channel in getCompromiseChannels" :key="channel.channel">
        <name-linking-dynamic-zone-renderer
            v-if="channel && channelsContent[channel.channel]"
            :title="channel.name"
            :channel="channel"
            :components="channelsContent[channel.channel].components"
            :type="`${$t('charts.analysis.connection.activation.compromise')} (${getFirstName(channel.dominant)} >> ${getFirstName(channel.dominee)})`"
            :planets="chart?.chart?.planets || []"
            :names="[chart.meta.person1.name, chart.meta.person2.name]"
            is-compromise
            use-reverse-color
        />
      </div>
      <div v-if="getCompromiseChannels.length === 0 && !fetching" class="font-500">
        There are no compromise connections in this chart.
      </div>

      <slot name="unlock-prompt"/>
      <ProgressChecker class="pt-3" type="companionship" id="4" :has-prev="hasPrev" :has-next="hasNext"
                       :order="order"
                       @prevSection="$emit('prevSection')"
                       @nextSection="$emit('nextSection')"/>
    </div>
  </div>
</template>

<script>

import DynamicZoneRenderer from "../../renderer/DynamicZoneRenderer";
import {mapState} from "vuex";
import NameLinkingDynamicZoneRenderer from "../../renderer/NameLinkingDynamicZoneRenderer.vue";
import ProgressChecker from "@/components/charts/analysis/progress/ProgressChecker.vue";
import PartnershipAnalysis from "@/mixins/PartnershipAnalysis";

export default {
  mixins: [PartnershipAnalysis],
  components: {ProgressChecker, NameLinkingDynamicZoneRenderer, DynamicZoneRenderer},
  data(){
    return{
      audioKey: 0,
      tab: 0,
      content: null,
      channelsContent: {}
    }
  },

  computed:{
    ...mapState({
      chart: state => state.charts.chart
    }),
  },
  created(){
    this.getIntroduction('compromise');
    for (let channel of this.getCompromiseChannels) {
      this.getContentForChannel('compromise', 'channelsContent', channel.channel, {
        dominantChartId: channel.dominantChartId,
      });
    }
  },
}
</script>